import { z } from 'zod'

export const TemplateManageSchema = z.object({
  copyFrom: z.number().int().nonnegative().optional(),
  returnUrl: z.string().optional()
})
